// Update Avatar
export const UPDATE_AVATAR_REQUEST = 'UPDATE_AVATAR_REQUEST';
export const UPDATE_AVATAR_DONE = 'UPDATE_AVATAR_DONE';
export const UPDATE_AVATAR_FAILED = 'UPDATE_AVATAR_FAILED';
export const UPDATE_AVATAR_RESET = 'UPDATE_AVATAR_RESET';

// Remove Avatar
export const REMOVE_AVATAR_REQUEST = 'REMOVE_AVATAR_REQUEST';
export const REMOVE_AVATAR_DONE = 'REMOVE_AVATAR_DONE';
export const REMOVE_AVATAR_FAILED = 'REMOVE_AVATAR_FAILED';